import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';

export const props = withCompInfo<any, any>()(
  ['compData', 'metaSiteId', 'topology', 'translate'],
  ({ compData, metaSiteId, topology, translate }) => {
    const defaultAltText = translate(
      'Accessibility',
      'rive_read_a11y_rive_animation',
    );

    return {
      ...compData,
      alt: compData.alt.length ? compData.alt : defaultAltText,
      metaSiteId,
      topology,
    };
  },
);

export const stateRefs = withStateRefsValues(['reducedMotion']);

export default createComponentMapperModel({
  props,
  stateRefs,
});
